import React from 'react';
import { Link } from 'react-router-dom';
import { CalendarDaysIcon, MailIcon } from 'lucide-react';
export function GettingStarted() {
  return <div className="w-full" style={{
    backgroundColor: '#f8f6f0'
  }} data-id="element-2014">
      <div className="max-w-4xl mx-auto px-4 md:px-8" data-id="element-2015">
        <div className="mb-12" data-id="element-2016">
          <div className="bg-white rounded-xl p-6 md:p-8 shadow-sm border text-center" style={{
          borderColor: '#ede9e0'
        }} data-id="element-2017">
            <h2 className="text-2xl font-bold uppercase mb-4" style={{
            fontFamily: 'Oswald, sans-serif',
            color: '#1e3d2f'
          }} data-id="element-2018">
              Ready to Get Started?
            </h2>
            <p className="text-base mb-6 max-w-2xl mx-auto" style={{
            color: '#4a6a5a',
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-2019">
              Stop by our indoor range some Tuesday evening when the league is
              in session. Check our web site calendar for new shooter nights.
            </p>

            <div className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-2020">
              <Link to="/Calendar.html" className="flex items-center justify-center gap-2 px-6 py-3 rounded-lg font-semibold text-sm transition-all hover:opacity-90 w-full sm:w-auto" style={{
              backgroundColor: '#1e3d2f',
              color: '#ffffff',
              fontFamily: 'Inter, sans-serif'
            }} data-id="element-2021">
                <CalendarDaysIcon size={16} data-id="element-2022" />
                View Calendar
              </Link>
              <a href="mailto:lanejk@aol.com" className="flex items-center justify-center gap-2 px-6 py-3 rounded-lg font-semibold text-sm transition-all hover:opacity-90 w-full sm:w-auto" style={{
              backgroundColor: '#c8a84b',
              color: '#1a1a1a',
              fontFamily: 'Inter, sans-serif'
            }} data-id="element-2023">
                <MailIcon size={16} data-id="element-2024" />
                Email Questions
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>;
}